export default __webpack_public_path__ + "static/media/avatar-jarvisly.f4ed9872.png";